<template>

    <div class="about">
        <b-container fluid class="helper-fh">
            <b-row class="helper-fh">
                <b-col cols="12" class="helper-fh">




                  <div v-if="pageContent" class="pagecontent-wrapper">
                    <vue-showdown v-for="contentWrapper in pageContent" :markdown="contentWrapper.content"></vue-showdown>
                  </div>


                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>


export default {
  name: "About",

  mounted() {
    this.$store.dispatch('GET_INFOPAGE_CONTENT_FROM_API')

  },
  computed:{
    pageContent:function (){
      return this.$store.state.infopageContent
    }
  }
}
</script>

<style scoped>
.about{
  height: 100vh;
}
.pagecontent-wrapper{
text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
height: 100%;
  padding-top:2em;
  padding-bottom:2em;
}

.helper-fh{
  height: 100%;
}
</style>